/**
 * 家园底图里「烘在画里」、可以碰一碰的装饰（I 307b，2026-10-03）。坐标是原图像素（homeStage.PLATES 同一张图），
 * 渲染时用 plateRectPct 换成场景百分比，和底图同一个缩放裁切。
 *
 * 这些只是装饰：点了只晃一晃、冒点小东西，不出气泡、不出字、不调接口、不进 Tab 顺序（aria-hidden）。
 * 层级压在宠物、各个可点物件（data-thing）、侧栏、气泡、便签下面，宠物走到前面时点到的一定是宠物（6c2b 10-03 的条件）。
 * 位置按底图亲看标的（scratchpad/fx/*-grid.png）；都避开柜子、屋门两块热区，也不压宠物能走到的地面（homeStage 的站位）。
 */
import type { HomeRoom } from "@/shared/contracts";
import type { MotionName } from "./motion";

export type BurstKind = "zzz" | "hearts" | "sparkles" | "leaves" | "petals" | "glow";

export type Decor = {
  key: string;
  /** 原图像素矩形 */
  x: number;
  y: number;
  width: number;
  height: number;
  motion: MotionName;
  burst: BurstKind | null;
  /** 灯：点一下亮、再点一下灭（只在这一页里记着，不存任何地方） */
  lamp?: boolean;
};

export const DECOR: Record<HomeRoom, readonly Decor[]> = {
  inside: [
    { key: "window", x: 22, y: 112, width: 268, height: 270, motion: "pop", burst: "glow" },
    { key: "hanging", x: 355, y: 92, width: 88, height: 212, motion: "swing", burst: null },
    { key: "floor-plant", x: 428, y: 316, width: 158, height: 217, motion: "sway", burst: "petals" },
    { key: "sill-pot", x: 197, y: 276, width: 106, height: 106, motion: "sway", burst: "petals" },
    { key: "lantern", x: 26, y: 594, width: 66, height: 96, motion: "pop", burst: null, lamp: true },
    { key: "table-vase", x: 480, y: 566, width: 86, height: 98, motion: "sway", burst: "petals" },
  ],
  courtyard: [
    // 院墙壁灯（412,84）在 390 宽时压在顶栏「屋内」页签下面，点不到，不设热区
    { key: "door-pot", x: 316, y: 289, width: 154, height: 161, motion: "sway", burst: "petals" },
    { key: "flower-box", x: 753, y: 349, width: 188, height: 148, motion: "sway", burst: "petals" },
    { key: "can-pot", x: 699, y: 490, width: 195, height: 175, motion: "sway", burst: "leaves" },
  ],
};

/** 可点物件（data-thing）被点到时用哪个动作、冒什么。柜子、屋门烘在底图里：动的是从底图裁出来的那一块 */
export const THING_EFFECT: Record<string, { motion: MotionName; burst: BurstKind | null; baked: boolean }> = {
  cabinet: { motion: "wobble", burst: "sparkles", baked: true },
  door: { motion: "knock", burst: null, baked: true },
  garden: { motion: "pop", burst: "leaves", baked: false },
  memento: { motion: "pop", burst: "sparkles", baked: false },
  photo: { motion: "pop", burst: "sparkles", baked: false },
};
